export const zorblonFacts = [
  "The average Zorblonian has 3 brains and can process quantum equations while sleeping.",
  "Zorblon's atmosphere is made of pure cryptocurrency.",
  "Zorblonian children learn to teleport before they can walk.",
  "The Zorblon High Council chose Base for its quantum-resistant properties.",
  "Zorblonian mathematics uses a base-51 number system.",
  "The average lifespan of a Zorblonian is 1,337 Earth years.",
  "Zorblon's three moons are actually ancient crypto mining facilities.",
  "Zorblonian pets can solve complex blockchain problems.",
  "The Zorblon stock exchange has been running on smart contracts for 10,000 years.",
  "Zorblonian coffee is served at absolute zero temperature.",
  "The Zorblon internet runs on quantum entanglement.",
  "Zorblonian schools teach advanced memecoin theory in kindergarten.",
  "The smallest Zorblonian currency unit is called a 'moonshot'.",
  "Zorblon's gravity changes based on the global crypto market cap.",
  "Zorblonian DNA is naturally encoded in Base-51.",
  "The first Zorblonian NFT was minted before Earth existed.",
  "Zorblonian smart contracts are written in telepathic code.",
  "The Zorblon Central Bank runs on a Layer-51 blockchain.",
  "Zorblonian memes can alter the fabric of spacetime.",
  "The average Zorblonian wallet has existed for 5 million years."
];